{
	"flowId": "praxis-proethica-candidate-onboarding",
	"enabled": true,
	"steps": [
		{
			"id": "why-it-matters",
			"title": "Why it matters",
			"headline": "Modern Ethics Training for Today's Educators",
			"description": "ProEthica develops the critical skills educators need to navigate ethical challenges in today’s classrooms.",
			"cta": "Continue"
		},
		{
			"id": "what-you-will-practice",
			"title": "What you will practice",
			"description": "Through authentic scenarios, guided reflection, and targeted feedback, learners strengthen professional judgement before challenges arise.",
			"cta": "Continue"
		},
		{
			"id": "confirm-details",
			"title": "Confirm your details",
			"description": "We use this information to connect your progress to the right institution and program.",
			"cta": "Looks right"
		},
		{
			"id": "how-you-will-begin",
			"title": "How you will begin",
			"description": "You can work at your own pace, pause and resume, and use your dashboard to continue assigned modules.",
			"cta": "Start Module 1"
		}
	],
	"programDescription": "You'll work through realistic scenarios, stakeholder perspectives, reflection prompts, ProEthics principles, and decision analysis.",
	"curriculumFraming": "Each module focuses on a different dimension of professional ethical responsibility.",
	"startNote": "You'll start with Module 1: Professional Ethics for Educators to learn the ethical framework and ProEthics principles used throughout the program. After that, you can choose the remaining assigned modules in the order that works for you.",
	"outcomes": [
		{
			"icon": "handshake-outline",
			"title": "Professional Boundaries",
			"description": "Navigate educator-student and parent relationships"
		},
		{
			"icon": "shield-check-outline",
			"title": "Digital Responsibility",
			"description": "Engage responsibly with AI, social media, and emerging technologies"
		},
		{
			"icon": "lightbulb-on-outline",
			"title": "Ethical Decision Making",
			"description": "Recognize and respond to ethical gray areas"
		},
		{
			"icon": "alert-outline",
			"title": "Risk Awareness",
			"description": "Predict outcomes and mitigate risk in complex situations"
		}
	],
	"experience": [
		{
			"icon": "play-box-outline",
			"title": "Realistic scenarios",
			"description": "Video-based situations introduce ethically ambiguous choices educators can face in practice."
		},
		{
			"icon": "account-group-outline",
			"title": "Stakeholder perspectives",
			"description": "Multiple viewpoints broaden the decision context and surface competing responsibilities."
		},
		{
			"icon": "comment-question-outline",
			"title": "Reflection and principles",
			"description": "Prompts and ProEthics principles help you connect instinctive responses to professional standards."
		},
		{
			"icon": "clipboard-text-search-outline",
			"title": "Analysis and checks",
			"description": "Decision analysis and short checks reinforce how to apply the framework."
		}
	],
	"expectations": [
		{
			"icon": "clock-outline",
			"title": "Self-paced",
			"description": "Move through modules on your own schedule."
		},
		{
			"icon": "pause-circle-outline",
			"title": "Pause and resume",
			"description": "Your progress is saved as you work."
		},
		{
			"icon": "clipboard-check-outline",
			"title": "Short checks",
			"description": "Activities help reinforce key decisions."
		},
		{
			"icon": "school-outline",
			"title": "Program visibility",
			"description": "Your institution can view assigned completion progress."
		},
		{
			"icon": "help-circle-outline",
			"title": "Support available",
			"description": "Contact support if account or access details look wrong."
		}
	]
}
